/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{Technique as s}from"./Technique.js";class t extends s{constructor(){super(...arguments),this.symbologyPlane=0,this._input=null}}export{t as FeatureTechnique};
